import {
  httpClient,
  apiRoutes,
  type DefaultQueryError,
} from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import type { SubscriptionResponse } from './types';

export const getSubscriptionListFn = async () => {
  const response = await httpClient.get<SubscriptionResponse>(
    `${apiRoutes.subscription.subscription_list}`
  );
  return response.data;
};

export const useGetSubscriptionList = (
  opts?: Omit<
    UseQueryOptions<SubscriptionResponse, DefaultQueryError>,
    'queryKey'
  >
) =>
  useQuery<SubscriptionResponse, DefaultQueryError>({
    queryKey: [apiRoutes.subscription.subscription_list],
    queryFn: () => getSubscriptionListFn(),
    ...opts,
  });
